/**
 * O que o modelo de visão viu na foto, campo a campo.
 *
 * Fechado por padrão: é o que se abre para entender por que o prompt saiu como
 * saiu — no detalhe do item e na hora de corrigi-lo.
 */
export function AnaliseDaFoto({ descricao }: { descricao: Record<string, string> }) {
  if (Object.keys(descricao).length === 0) return null;

  return (
    <details className="rounded-peca border border-borda bg-superficie px-4 py-3">
      <summary className="cursor-pointer text-[0.8125rem] font-medium text-texto">
        O que o modelo viu na foto
      </summary>
      <dl className="mt-3 flex flex-col gap-2">
        {Object.entries(descricao).map(([chave, valor]) => (
          <div key={chave}>
            <dt className="text-[0.75rem] uppercase tracking-[0.08em] text-texto-fraco">{chave}</dt>
            <dd className="text-[0.8125rem] leading-relaxed text-texto-suave">{valor}</dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
